import * as React from 'react';

import Slider from '@material-ui/core/Slider';
import { styled } from '@material-ui/core/styles';
import translate from '../../../i18n/translate';
import { Box } from 'grommet';

const marks = [
    {
        value: 0,
        label: translate('logement_type'),
    },
    {
        value: 10,
        label: translate('declaration'),
    },
    {
        value: 20,
        label: translate('critere_logement'),
    },
    {
        value: 30,
        label: translate('vos_informations'),
    },
    {
        value: 40,
        label: translate('option_prix'),
    },
    {
        value: 50,
        label: translate('recapitulatif'),
    },
    {
        value: 60,
        label: translate('serez_assure'),
    }
];


function valuetext(value) {
    return '';
}

const StyledSlider = styled(Slider)({
    color: '#E92C70',
    marginTop: 10,
    height: 8,
    '& .MuiSlider-track': {
        border: 'none',
        height: 3,
    },
    '& .MuiSlider-rail': {
        border: 'none',
        height: 3,
        color: '#707070'
    },
    '& .MuiSlider-thumb': {
        height: 8,
        width: 8,
        marginTop: -3,
        marginLeft: -4,
        backgroundColor: '#fff',
        border: '2px solid currentColor',
        '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
            boxShadow: 'inherit',
        },
        '&:before': {
            display: 'none',
        },
    },
    '& .MuiSlider-mark': {
        backgroundColor: '#fff',
        height: 8,
        width: 8,
        fontSize: 5,
        marginTop: -3,
        marginLeft: -4,
        border: '1px solid currentColor',
        borderRadius: 5,
        '&.MuiSlider-markActive': {
            opacity: 1,
            backgroundColor: 'currentColor',
        },
    },
    '& .MuiSlider-markLabel': {
        fontSize: 11
    },
    '& .MuiSlider-valueLabel': {
        lineHeight: 1.2,
        fontSize: 11,
        background: 'unset',
        padding: 0,
        width: 200,
        height: 50,
        marginLeft: -90,
        fontWeight: 'bold',
        '& *': {
            display: 'block',
            background: 'transparent',
            color: '#707070',
            fontWeight: 'bold',
            transform: 'rotate(0deg)',
            width: 200,
            borderRadius: 0,
            marginTop: 19,
            fontSize: 18,
            textAlign: 'center',
        },
    },
});

const ResStepProgress = ({ value, submitable = true }) => {
    value = submitable ? value : 60;
    
    return (<Box justify='center' align='center' style={{ width: 280 }}>
        <StyledSlider
            defaultValue={0}
            aria-labelledby="track-false-slider"
            getAriaValueText={valuetext}
            step={10}
            marks={marks.map(f=> Object.assign({}, f)).filter(v => {
                if(v.value !== value) v.label = '';
                return true;
            })}
            max={60}
            min={0}
            value={value}
        />
    </Box>)
}

export default ResStepProgress;